import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useToggledSwitches } from '../../context/ToggledSwitchesContext'
import UISchoolMenu from './UISchoolMenu'
import UINotificationMenu from './UINotificationMenu'
import { Icon } from '../Icon'

const UIHeader = () => {
  const navigate = useNavigate()
  const { schoolCount, toggledSwitches } = useToggledSwitches()
  const wrapperRefScrollMenu = useRef<HTMLDivElement>(null)
  const wrapperRefNotificationMenu = useRef<HTMLDivElement>(null)
  const [isOpenSchool, setIsOpenSchool] = useState<boolean>(false)
  const [isOpenNotification, setIsOpenNotification] = useState<boolean>(false)
  const { logout } = useAuth()

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        wrapperRefScrollMenu.current &&
        !wrapperRefScrollMenu.current.contains(event.target as Node)
      ) {
        setIsOpenSchool(false)
      }
      if (
        wrapperRefNotificationMenu.current &&
        !wrapperRefNotificationMenu.current.contains(event.target as Node)
      ) {
        setIsOpenNotification(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const handleToggleSchool = () => {
    setIsOpenSchool(!isOpenSchool)
  }

  const handleToggleNotification = () => {
    setIsOpenNotification(!isOpenNotification)
  }

  const handleItemClick = () => {
    logout()
  }

  const menuItems = [
    {
      label: 'Logout',
      onClick: handleItemClick,
      icon: '',
      iconColor: '',
    },
  ]

  const userRole = localStorage.getItem('userRole')
  const schoolName = localStorage.getItem('schoolName')
  const userName = localStorage.getItem('userName')

  return (
    <div className="w-full lg:w-calc(100% - 72) bg-gray1 h-24 flex items-center justify-end px-5">
      {userRole !== 'super' && (
        <>
          <div className="bg-white p-3 rounded-full flex items-center justify-center mx-2 cursor-pointer">
            <Icon
              name="IconBuilding"
              stroke="#02698C"
              width={16}
              height={16}
              strokeWidth={2}
            />
            <p className="text-bluishGreen font-semibold text-[14px]">
              {schoolName}
            </p>
          </div>
          <div className="bg-white p-3 rounded-full flex items-center justify-center mx-2 cursor-pointer">
            <p className="text-bluishGreen font-semibold text-[14px]">
              {userName === 'undefined' ? '' : userName}
            </p>
          </div>
        </>
      )}
      {[
        'Admin / DSL',
        'DSL',
        'Admin',
        'Staff',
        'Governor',
        'Group DSL',
        'Group Admin',
        'Group Admin / DSL',
        'Group Governor',
      ].includes(userRole || '') && (
        <UISchoolMenu
          wrapperRefScrollMenu={wrapperRefScrollMenu}
          isOpen={isOpenSchool}
          items={menuItems}
          type="btn"
          display={[
            'Admin / DSL',
            'DSL',
            'Admin',
            'Staff',
            'Governor',
            'Group Staff',
          ].includes(userRole || '')}
        >
          <div
            className="w-[280px] h-[48px] p-3 rounded-[12px] bg-white mx-2 justify-between flex items-center gap-2"
            onClick={handleToggleSchool}
          >
            <div className="w-[100px] h-[20px] rounded-full bg-green flex justify-center items-center">
              <p className="text-white font-medium text-[10px]">
                {toggledSwitches?.length} out of {schoolCount}
              </p>
            </div>
            <div className="flex justify-center items-center gap-3">
              <p className="text-bluishGreen font-semibold text-[14px]">
                Schools Selected
              </p>
              <Icon
                name="IconChevronDown"
                stroke="#02698C"
                width={16}
                height={16}
                strokeWidth={1}
              />
            </div>
          </div>
        </UISchoolMenu>
      )}
      <div
        onClick={() => navigate('/home/settings')}
        className="bg-white h-12 w-12 rounded-full flex items-center justify-center mx-2 cursor-pointer"
      >
        <Icon name="IconSetting" strokeWidth={1} stroke="#02698C" />
      </div>
      {[
        'Admin / DSL',
        'DSL',
        'super',
        'Admin',
        'Staff',
        'Governor',
        'Group Staff',
        'Group Governor',
        'Group Admin',
        'Group Admin / DSL',
        'Group DSL',
      ].includes(userRole || '') && (
        <UINotificationMenu
          isOpen={isOpenNotification}
          wrapperRefNotificationMenu={wrapperRefNotificationMenu}
        >
          <div
            onClick={handleToggleNotification}
            className="bg-white h-12 w-12 rounded-full flex items-center justify-center mx-2 cursor-pointer"
          >
            <Icon name="IconBellAlert" strokeWidth={1} stroke="#02698C" />
          </div>
        </UINotificationMenu>
      )}
    </div>
  )
}

export default UIHeader
